import { render } from "./CollaborationSection.vue?vue&type=template&id=af5c7346&scoped=true"
import script from "./CollaborationSection.vue?vue&type=script&lang=js"
export * from "./CollaborationSection.vue?vue&type=script&lang=js"

import "./CollaborationSection.vue?vue&type=style&index=0&id=af5c7346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5c7346"]])

export default __exports__